import { ToggleContent } from "./ToggleContent.js";

/**
 * Class to implement the toggle-content manager
 * as a singleton, which can be instantiated by
 * any other extension as a dependency
 */
export class ToggleContentManager {
    private static manager: ToggleContentManager;
    private instances: ToggleContent[] = [];

    /**
     * The private constructor
     * prevents direct instantiation
     */
    private constructor() {
        this.scopes.forEach((scope) => {
            this.instances.push(new ToggleContent(scope));
        });
    }

    /**
     * Method to instantiate all
     * toggle-contents on the current page
     *
     * @param {boolean} [reset=false]
     * @returns {ToggleContentManager}
     */
    public static use(reset: boolean = false): ToggleContentManager {
        if (!ToggleContentManager.manager || reset) {
            ToggleContentManager.manager = new ToggleContentManager();
        }
        return ToggleContentManager.manager;
    }

    /**
     * Selects the toggle-contents
     *
     * @returns {NodeListOf<HTMLElement>}
     */
    protected get scopes(): NodeListOf<HTMLElement> {
        return document.querySelectorAll(`[scope="toggle-content"]`);
    }

    /**
     * Returns the number of instances
     *
     * @returns {number}
     */
    public get length(): number {
        return this.instances.length;
    }
}
